import AppointmentCalendar from '../../components/appointment/AppointmentCalendar';

export default function AppointmentCalendarPage() {
  return <AppointmentCalendar />;
}
